<template>
	<v-dialog v-model="dialog" max-width="650px" persistent>
		<v-snackbar v-model="snackbar.show" top :color="snackbar.color" :timeout="snackbar.timeout">
			{{ snackbar.message }}
			<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false"> Close </v-btn>
		</v-snackbar>
		<v-card>
			<v-toolbar flat dense>
				<v-toolbar-title class="subheading"><v-icon class="mr-2">mail_outline</v-icon>{{ title }}</v-toolbar-title>
			</v-toolbar>

			<v-card-text class="text-xs-left">
				<slot name="header"> </slot>

				<recipients-input v-model="form.recipients" />
				<div v-if="recipientErrors.length > 0" class="error--text mb-3" style="margin-top: -12px;">{{ recipientErrors[0] }}</div>

				<v-text-field v-model="form.emailSubject" class="mb-2" :error-messages="subjectErrors" label="Subject" required></v-text-field>

				<textarea id="sun-editor" ref="sunEditor"></textarea>

				<div class="text-xs-right"><a @click="resetBody">Reset</a></div>

				<slot name="below-body"> </slot>

				<div v-if="bodyErrors.length > 0" class="mt-2 error--text">{{ bodyErrors[0] }}</div>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="onCancel">Cancel</v-btn>
				<v-btn flat color="primary" :loading="isSending" :disabled="isSending" @click="onSend">
					Send
					<span slot="loader">Sending...</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import RecipientsInput from '@/components/email/RecipientsInput';
	import userEmailsApi from '@/api/userEmails.api';

	import suneditor from 'suneditor';
	import plugins from 'suneditor/src/plugins';

	export default {
		components: {
			RecipientsInput
		},
		mixins: [validationMixin],
		props: {
			dialog: {
				type: Boolean,
				default: false
			},
			recipients: {
				type: Array,
				required: false
			},
			subject: {
				type: String,
				default: ''
			},
			body: {
				type: String,
				default: ''
			},
			title: {
				type: String,
				default: 'Send Email'
			}
		},
		data() {
			return {
				editor: null,
				form: {
					emailBody: this.body,
					emailSubject: this.subject,
					recipients: this.recipients ? [...this.recipients] : []
				},
				isSending: false,
				snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink',
					timeout: 6000
				}
			};
		},
		computed: {
			bodyErrors() {
				const errors = [];
				if (!this.$v.form.emailBody.$dirty) return errors;
				!this.$v.form.emailBody.required && errors.push('Email Body is required.');
				return errors;
			},
			recipientErrors() {
				const errors = [];
				if (!this.$v.form.recipients.$dirty) return errors;
				!this.$v.form.recipients.required && errors.push('At least one recipient is required.');
				return errors;
			},
			subjectErrors() {
				const errors = [];
				if (!this.$v.form.emailSubject.$dirty) return errors;
				!this.$v.form.emailSubject.required && errors.push('Subject is required.');
				return errors;
			}
		},
        mounted() {
			this.editor = suneditor.create('sun-editor', {
				placeholder: '',
				value: this.form.emailBody,
				plugins: plugins,
				width: '100%',
				height: '100%',
				buttonList: [
					['undo', 'redo', 'fontSize', 'formatBlock'],
					['bold', 'underline', 'italic', 'strike', 'removeFormat'],
					['horizontalRule', 'list', 'table', 'link'],
				]
			});
			this.editor.onChange = () => {
				this.form.emailBody = this.editor.getContents();
			};
		},
		methods: {
			resetBody() {
				this.form.emailBody = this.body;
                this.editor.setContents(this.body);
			},
			onSend() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					this.isSending = true;

					const sendData = {
						to: this.form.recipients,
						subject: this.form.emailSubject,
						body: this.form.emailBody,
						signatureIncluded: true
					};

					userEmailsApi
						.post(sendData)
						.then(resp => {
							this.isSending = false;
							this.$emit('onSent', sendData);
						})
						.catch(err => {
							this.isSending = false;
							this.showSnackbar('Email could not be sent at this time', true);
						});
				}
			},
			onCancel() {
				this.$emit('onCancel');
			},
			showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : undefined;
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000;
			}
		},
		validations() {
			return {
				form: {
					recipients: { required },
					emailBody: { required },
					emailSubject: { required }
				}
			};
		}
	};
</script>

<style scoped></style>
